import "core-js/modules/es6.regexp.split";
export var getClassName = function getClassName(defaultClassName, className) {
  return className ? className.split(' ').concat(defaultClassName).join(' ') : defaultClassName.join(' ');
};